import React, { Component, Fragment } from 'react';
import { Content, RoundsContent } from './style';
import SummaryHeader from './SummaryHeader';
import { InfoHeader } from './InfoHeader';
import {
    WorkoutPlanEmptyState,
    UnauthorizedWorkoutPlannerState,
} from '../../../Components/BannerEmptyStats/BannerEmptyStats';
import { EmptyState } from '../../WithEmptyState/EmptyState';
import { AddedExercise } from './AddedExercise';
import { Text } from '../../../UI/Text';
import PropTypes from 'prop-types';
import { RoundRow } from './RoundRow';
import ModalContainer from '../../Modals/ModalContainer';
import { ChooseWorkoutTypeModal } from '../../../Components/Modals/ChooseWorkoutTypeModal';
import { AddWorkoutDescriptionModal } from '../../../Components/Modals/AddWorkoutDescriptionModal';
import { WorkoutPlanSettingsModal } from '../../../Components/Modals/WorkoutPlanSettingsModal';
import { handleLoginService } from '../../../../Services/handleLocalStorage';

const TOGGLE_WORKOUT_TYPE_MODAL = 'workoutTypeModalState';
const TOGGLE_DESCRIPTION_MODAL = 'descriptionModalState';
const TOGGLE_SETTINGS_MODAL = 'settingsModalState';

class RightBox extends Component {
    state = {
        descriptionModalState: false,
        workoutTypeModalState: false,
        settingsModalState: false,
    };

    toggleModal = modal => {
        this.setState({ [modal]: !this.state[modal] });
    };

    render() {
        const {
            props: {
                rounds,
                actions,
                modalActions,
                summary,
                workoutType,
                workoutTitle,
                workoutDescription,
                settings,
                workoutImage,
                submitWorkout,
                disableSubmitButton,
            },
            state: { descriptionModalState, workoutTypeModalState, settingsModalState },
            toggleModal,
        } = this;
        const isEmpty = rounds.length === 1 && rounds[0].length === 0;

        return (
            <Content>
                {/* Workout type modal toggle */}
                {workoutTypeModalState && (
                    <ModalContainer>
                        <ChooseWorkoutTypeModal
                            onClose={toggleModal.bind(this, TOGGLE_WORKOUT_TYPE_MODAL)}
                            onChoose={modalActions.selectWorkoutType}
                        />
                    </ModalContainer>
                )}
                {/* Workout description modal */}
                {descriptionModalState && (
                    <ModalContainer>
                        <AddWorkoutDescriptionModal
                            onClose={toggleModal.bind(this, TOGGLE_DESCRIPTION_MODAL)}
                            onDescriptionSet={modalActions.addWorkoutDescription}
                            description={workoutDescription}
                        />
                    </ModalContainer>
                )}
                {/* Workout plan settings modal */}
                {settingsModalState && (
                    <ModalContainer>
                        <WorkoutPlanSettingsModal
                            {...settings}
                            onClose={toggleModal.bind(this, TOGGLE_SETTINGS_MODAL)}
                            defineSettings={modalActions.defineWorkoutSettings}
                        />
                    </ModalContainer>
                )}
                <SummaryHeader
                    workoutImage={workoutImage}
                    workoutTitle={workoutTitle}
                    actions={modalActions}
                    workoutDescription={workoutDescription}
                    handleInputChange={actions.editWorkoutFields}
                    workoutType={workoutType}
                    summary={summary}
                    settings={settings}
                    toggleModal={toggleModal}
                    disableSubmitButton={disableSubmitButton}
                    submitWorkout={submitWorkout}
                />
                <InfoHeader />
                <RoundsContent>
                    {handleLoginService.isAuthenticated() ? (
                        <EmptyState
                            isEmpty={isEmpty}
                            emptyState={() => (
                                <WorkoutPlanEmptyState
                                    toggleAdvancedSettings={toggleModal.bind(this, TOGGLE_SETTINGS_MODAL)}
                                />
                            )}
                        >
                            <RenderRounds rounds={rounds} actions={actions} />
                            <AddRoundButton onClick={actions.addNewRound}>Add round</AddRoundButton>
                        </EmptyState>
                    ) : (
                        <UnauthorizedWorkoutPlannerState />
                    )}
                </RoundsContent>
            </Content>
        );
    }
}

const RenderRounds = ({ rounds, actions }) => {
    return rounds.map((round, roundIndex) => {
        return (
            <Fragment key={`fragment-${roundIndex}`}>
                <RoundRow actions={actions} index={roundIndex} key={`round-${roundIndex}`} />
                {round.map((exercise, index) => (
                    <AddedExercise
                        key={`added-${roundIndex}-${index}`}
                        {...exercise}
                        roundIndex={roundIndex}
                        actions={actions}
                        index={index}
                    />
                ))}
            </Fragment>
        );
    });
};

const AddRoundButton = ({ onClick, children }) => (
    <Text
        uppercase={true}
        fontSize={12}
        weight={'bold'}
        marginTop={'15px'}
        opacity={0.5}
        marginLeft={'12px'}
        onClick={onClick}
        cursor={'pointer'}
    >
        {children}
    </Text>
);

RightBox.propTypes = {
    summary: PropTypes.object.isRequired,
    modalActions: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    rounds: PropTypes.array.isRequired,
    workoutType: PropTypes.number.isRequired,
    workoutTitle: PropTypes.string.isRequired,
    settings: PropTypes.object.isRequired,
};

export default RightBox;



// WEBPACK FOOTER //
// ./src/UI/Containers/WorkoutPlan/RightBox/index.js